// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* View User Modal Styles - Admin exclusive */
.view-user-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.view-user-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
  max-width: 900px;
  width: 95vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: viewUserModalSlideIn 0.3s ease-out;
}

@keyframes viewUserModalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.view-user-modal-header {
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view-user-modal-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
}

.view-user-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.view-user-modal-close:hover {
  background-color: #f1f5f9;
  color: #374151;
}

.view-user-modal-content {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.admin-user-info-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.admin-user-info-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.admin-user-info-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
  color: #1e293b;
  font-weight: 600;
}

.admin-user-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.admin-user-info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.admin-user-info-item label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.admin-user-info-item span {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}

.admin-user-no-wallet {
  grid-column: 1 / -1;
  text-align: center;
  padding: 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
  color: #64748b;
  font-style: italic;
}

/* Badge Styles */
.admin-user-role-badge,
.admin-user-status-badge,
.admin-user-verified-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.admin-user-role-admin {
  background-color: #ede9fe;
  color: #7c3aed;
}

.admin-user-role-user {
  background-color: #dbeafe;
  color: #2563eb;
}

.admin-user-status-active {
  background-color: #d1fae5;
  color: #065f46;
}

.admin-user-status-inactive {
  background-color: #fee2e2;
  color: #991b1b;
}

.admin-user-verified-verified {
  background-color: #d1fae5;
  color: #065f46;
}

.admin-user-verified-unverified {
  background-color: #fef3c7;
  color: #92400e;
}

.admin-user-balance {
  font-weight: 700;
  color: #059669;
  font-size: 1rem;
}


/* Recent Bets */
.admin-user-recent-bets {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.admin-user-bet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.admin-user-bet-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.admin-user-bet-tournament {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.admin-user-bet-amount {
  font-weight: 600;
  color: #059669;
  font-size: 0.875rem;
}

.admin-user-bet-status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.admin-user-bet-status-active {
  background-color: #dbeafe;
  color: #2563eb;
}

.admin-user-bet-status-won {
  background-color: #d1fae5;
  color: #065f46;
}

.admin-user-bet-status-lost {
  background-color: #fee2e2;
  color: #991b1b;
}

.admin-user-bet-status-pending {
  background-color: #fef3c7;
  color: #92400e;
}

.view-user-modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  background-color: #f8fafc;
}

/* Responsive Design */
@media (max-width: 768px) {
  .view-user-modal {
    width: 95vw;
    max-width: none;
    margin: 1rem;
  }
  
  .admin-user-info-grid {
    grid-template-columns: 1fr;
  }
  
  .admin-user-bet-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .view-user-modal-header {
    padding: 1rem;
  }
  
  .view-user-modal-header h2 {
    font-size: 1.25rem;
  }
  
  .view-user-modal-content {
    padding: 1rem;
  }
  
  .view-user-modal-footer {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/modals/ViewUserModal.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;;EAGE,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;;AAGA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* View User Modal Styles - Admin exclusive */\n.view-user-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.view-user-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);\n  max-width: 900px;\n  width: 95vw;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: viewUserModalSlideIn 0.3s ease-out;\n}\n\n@keyframes viewUserModalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.view-user-modal-header {\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.view-user-modal-header h2 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.view-user-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.view-user-modal-close:hover {\n  background-color: #f1f5f9;\n  color: #374151;\n}\n\n.view-user-modal-content {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.admin-user-info-section {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.admin-user-info-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.admin-user-info-section h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.25rem;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.admin-user-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.admin-user-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.admin-user-info-item label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.admin-user-info-item span {\n  font-size: 0.875rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.admin-user-no-wallet {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 1rem;\n  background-color: #f8fafc;\n  border-radius: 8px;\n  color: #64748b;\n  font-style: italic;\n}\n\n/* Badge Styles */\n.admin-user-role-badge,\n.admin-user-status-badge,\n.admin-user-verified-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.admin-user-role-admin {\n  background-color: #ede9fe;\n  color: #7c3aed;\n}\n\n.admin-user-role-user {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.admin-user-status-active {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.admin-user-status-inactive {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.admin-user-verified-verified {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.admin-user-verified-unverified {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.admin-user-balance {\n  font-weight: 700;\n  color: #059669;\n  font-size: 1rem;\n}\n\n\n/* Recent Bets */\n.admin-user-recent-bets {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.admin-user-bet-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background-color: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.admin-user-bet-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.admin-user-bet-tournament {\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.admin-user-bet-amount {\n  font-weight: 600;\n  color: #059669;\n  font-size: 0.875rem;\n}\n\n.admin-user-bet-status-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.admin-user-bet-status-active {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.admin-user-bet-status-won {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.admin-user-bet-status-lost {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.admin-user-bet-status-pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.view-user-modal-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  background-color: #f8fafc;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .view-user-modal {\n    width: 95vw;\n    max-width: none;\n    margin: 1rem;\n  }\n  \n  .admin-user-info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .admin-user-bet-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .view-user-modal-header {\n    padding: 1rem;\n  }\n  \n  .view-user-modal-header h2 {\n    font-size: 1.25rem;\n  }\n  \n  .view-user-modal-content {\n    padding: 1rem;\n  }\n  \n  .view-user-modal-footer {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
